import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { orgLoaderHandler } from "src/lib/orgLoaderHandler";
import { OrganizationAthletesPage } from "src/pages/OrganizationAthletesPage";
import { organizationAthletesQueryOptions } from "src/queries/organizationAthletes";

export const ORGANIZATION_ATHLETES_DEFAULT_PAGE_SIZE = 10;

const searchSchema = z.object({
  q: z.string().optional(),
  p: z.coerce.number().optional(),
  ps: z.coerce.number().optional(),
});

export const Route = createFileRoute("/_auth/_coach/orgs/$slug/athletes/")({
  component: OrganizationAthletesPage,
  validateSearch: searchSchema,
  ssr: true,
  loaderDeps: ({ search }) => ({
    pageIndex: search.p || 0,
    pageSize: search.ps || ORGANIZATION_ATHLETES_DEFAULT_PAGE_SIZE,
    query: search.q || "",
    status: "active" as const,
  }),
  async loader({ context, deps, params }) {
    return orgLoaderHandler(
      { queryClient: context.queryClient, slug: params.slug },
      async ({ organization }) => {
        await context.queryClient.query({
          ...organizationAthletesQueryOptions(organization.id, deps),
          staleTime: "static",
        });
        return { data: null };
      },
    );
  },
});
